import React from "react";
import styled from "styled-components";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Typography from "@material-ui/core/Typography";
import { useTranslation, Trans } from 'react-i18next';
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup"
import { FormHelperText, makeStyles } from "@material-ui/core";

const schema = yup.object().shape({
  // agreeTerms: yup.boolean().oneOf([true],'Message'),
  // want_promo: yup.boolean(),
});

const useStylesAll = makeStyles(theme => ({
  pageContainer: {
    position: "absolute",
    width: "100%",
    fontFamily: "Poppins",
  },
  container: {
    width: "85%",
    backgroundColor: '#FFFFFF',
    margin: "30px auto",
    color: "#000000",
    padding: "10px 15px",
    [theme.breakpoints.up('md')]: {
      margin: "20vh auto",
      width: 625,
      padding: "30px",
    },
    '@media (max-height:750px)': {
      marginTop: '180px',
    }
  },
  content: {
    border: "1px solid #CCCCCC",
    padding: "20px",
    overflowY: "scroll",
    height: "400px",
    marginBottom: "15px",
  },
  // checkbox: {
  //   color: "#CCCCCC",
  //   '&.Mui-checked': {
  //     color: "#000000",
  //   },
  // },
  label: {
    // whiteSpace: "nowrap",
    [theme.breakpoints.up('sm')]: {
      display: "block",
    },
    '& .MuiTypography-body1': {
      fontSize: "13px",
      
      [theme.breakpoints.up('sm')]: {
        fontSize: "14px",
      },
    }
  },
  btn: {
    marginTop: "30px",
    [theme.breakpoints.up('md')]: {
      marginTop: "40px",
    },
  },
}));



function TncPage(props) {
  const { currentStep, agreeTerms, notReceivePromotion, handleChange, errorMessage } = props;
  const { t, i18n } = useTranslation('register');
  const classes = useStylesAll();
  const [isDisabled, setIsDisabled] = React.useState(true);
  const lng = i18n.language;

  const {
    control,
    register,
    handleSubmit,
    watch,
    getValues,
    setValue,
    reset,
    formState,
  } = useForm({
    resolver: yupResolver(schema),
  });

  function handleScroll(e) {
    // const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    var scrollTo = e.target.scrollHeight - e.target.scrollTop;
    var diff = scrollTo - e.target.clientHeight;
    const bottom = diff < 28 && diff > -28;
    if (bottom) {
      setIsDisabled(false);
    }
  }

  return (
    currentStep == 0 ?
      <>
        <Typography variant="h1">{t('tnc.title')}</Typography>
        <Typography variant="body1" className={classes.content} onScroll={handleScroll}>
          <Trans t={t} i18nKey="tnc.content" components={[<span style={{textDecoration: "underline", fontWeight: "700"}}/>, <br/>, <b/>, <u/>]}>
            
          </Trans>
        </Typography>
        <Controller
          name="agreeTerms"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <>
              <FormControlLabel
                className={classes.label}
                control={
                  <Checkbox
                    id="agreeTerms"
                    className={classes.checkbox}
                    type="checkbox"
                    name="agreeTerms"
                    color="primary"
                    error={!!errorMessage.agreeTerms}
                    checked={agreeTerms}
                    onChange={handleChange}
                    disabled={isDisabled}
                  />
                }
                label={t('tnc.agreeTerms')}
              />
              <FormHelperText style={{color: "red"}}>
                {
                  errorMessage.agreeTerms &&
                  t(errorMessage.agreeTerms)
                }
              </FormHelperText>
            </>
          )}
        />

        <FormControlLabel
          className={classes.label}
          control={
            <Checkbox
              id="notReceivePromotion"
              className={classes.checkbox}
              type="checkbox"
              color="primary"
              name="notReceivePromotion"
              checked={notReceivePromotion}
              onChange={handleChange}
            />
          }
          label={t('tnc.notReceivePromotion')}
        />
      </>
      : <></>
  );
}

export default TncPage;
